<template>
  <div
    style="width: 100%; background: #ffffff"
    class="font-sans bg-gray-50 text-gray-800"
  >
    <div class="font-sans bg-gray-50 text-gray-800">
      <header
        class="fixed w-full top-0 z-50 transition-all duration-300 bg-white-90 backdrop-blur-sm shadow-sm"
        id="navbar"
        data-ytoriginindex="0"
        data-ytindex="0"
        style="background-color: #ffffff"
      >
        <div
          class="container mx-auto px-4 sm:px-6 lg:px-8"
          data-ytextravalue="extra-kv0qketld"
        >
          <div
            class="flex justify-between items-center h-16 md:h-20"
            data-ytparentvalue="extra-kv0qketld"
            data-ytoriginindex="0"
            data-ytindex="0"
          >
            <!-- Logo -->
            <div class="flex items-center">
              <a class="flex items-center" href="javascript:void(0);">
                <div class="w-10 h-10 mr-3">
                  <img :src="logo" alt="" />
                </div>
                <el-image
                  style="width: 100px; height: 32px; margin-left: 10px"
                  :src="logoTitle"
                  fit="fill"
                ></el-image>
                <!-- <span class="text-xl font-bold text-dark"> {{ name }} </span> -->
              </a>
            </div>
            <!-- 桌面导航 -->
            <nav class="hidden md:flex space-x-24">
              <a
                class="text-black hover:text-primary font-medium transition-colors cursor-pointer"
                data-yteditvalue
                @click="handleTop"
                style="font-weight: 600"
              >
                主页
              </a>
              <a
                class="text-black hover:text-primary font-medium transition-colors"
                href="#features"
                data-yteditvalue
                style="font-weight: 600"
              >
                功能介绍
              </a>
              <a
                class="text-black hover:text-primary font-medium transition-colors"
                href="#templates"
                data-yteditvalue
                style="font-weight: 600"
              >
                试用场景
              </a>
              <a
                class="text-black hover:text-primary font-medium transition-colors"
                href="#testimonials"
                data-yteditvalue
                style="font-weight: 600"
              >
                用户反馈
              </a>
            </nav>
            <!-- 登录/注册按钮 -->
            <div class="hidden md:flex items-center space-x-4">
              <!-- <a
                class="text-gray-600 hover:text-primary font-medium transition-colors"
                href="javascript:void(0);"
                @click="handleLoginClick"
              >
                登录
              </a> -->
              <a
                class="bg-primary hover:bg-primary/90 text-white px-4 py-2 rounded-lg font-medium transition-colors shadow-sm hover:shadow"
                href="javascript:void(0);"
                @click="handleLoginClick"
              >
                登录 / 注册
              </a>
            </div>
            <!-- 移动端菜单按钮 -->
            <div class="md:hidden">
              <button
                class="text-gray-600 hover:text-primary focus:outline-none"
                id="menu-toggle"
              >
                <i class="fas fa-bars text-xl"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- 移动端导航菜单 -->
        <div class="hidden md:hidden bg-white border-t" id="mobile-menu">
          <div class="container mx-auto px-4 py-3 space-y-3">
            <a
              class="block py-2 text-gray-600 hover:text-primary font-medium"
              href="#features"
            >
              功能特点
            </a>
            <a
              class="block py-2 text-gray-600 hover:text-primary font-medium"
              href="#templates"
            >
              模板中心
            </a>
            <a
              class="block py-2 text-gray-600 hover:text-primary font-medium"
              href="#testimonials"
            >
              用户评价
            </a>
            <div class="pt-2 border-t border-gray-100 flex flex-col space-y-3">
              <a
                class="text-center py-2 text-gray-600 hover:text-primary font-medium"
                href="javascript:void(0);"
              >
                登录
              </a>
              <a
                class="text-center bg-primary hover:bg-primary/90 text-white py-2 rounded-lg font-medium transition-colors"
                href="javascript:void(0);"
              >
                免费注册
              </a>
            </div>
          </div>
        </div>
      </header>
      <section
        class="pt-32 pb-20 md:pt-40 md:pb-32 bg-gradient-to-br from-blue-50 to-indigo-50"
        data-ytparentvalue="extra-54s1zielf"
        data-ytoriginindex="1"
        data-ytindex="1"
      >
        <div class="container container-overflow mx-auto px-4 sm:px-6 lg:px-8">
          <div class="flex flex-col lg:flex-row items-center">
            <div class="lg:w-1/2 mb-12 lg:mb-0">
              <h1
                class="text-[clamp(2rem,5vw,3.5rem)] font-bold leading-tight text-dark mb-6"
              >
                <p class="text-5xl">{{ name }}</p>
                <br />
                <p class="text-primary text-4xl">
                  快速制作 <span class="text-4xl text-black">多种问卷调研</span>
                </p>
              </h1>
              <p class="text-lg text-gray-600 mb-8 max-w-xl">
                {{
                  name
                }}支持海量问卷模板，快速创建问卷、支持数据收集到结果分析，让调研变得简单高效。
              </p>
              <div
                class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
              >
                <a
                  class="bg-primary hover:bg-primary/90 text-white px-8 py-3 rounded-md font-medium text-center transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all text-xl"
                  href="javascript:void(0);"
                  @click="handleLoginClick"
                >
                  立即免费创建
                </a>
              </div>
              <!-- <div class="mt-10 flex items-center space-x-4">
                <div class="flex -space-x-2">
                  <img
                    alt="用户头像"
                    class="w-10 h-10 rounded-full border-2 border-white"
                    src="https://design.gemcoder.com/staticResource/echoAiSystemImages/2c9b30effd3a1829022380e53bf512e1.png"
                  />
                  <img
                    alt="用户头像"
                    class="w-10 h-10 rounded-full border-2 border-white"
                    src="https://design.gemcoder.com/staticResource/echoAiSystemImages/2c9b30effd3a1829022380e53bf512e1.png"
                  />
                  <img
                    alt="用户头像"
                    class="w-10 h-10 rounded-full border-2 border-white"
                    src="https://design.gemcoder.com/staticResource/echoAiSystemImages/2c9b30effd3a1829022380e53bf512e1.png"
                  />
                  <img
                    alt="用户头像"
                    class="w-10 h-10 rounded-full border-2 border-white"
                    src="https://design.gemcoder.com/staticResource/echoAiSystemImages/2c9b30effd3a1829022380e53bf512e1.png"
                  />
                </div>
                <div>
                  <div class="flex items-center text-yellow-400 mb-1">
                    <i class="fas fa-star"> </i>
                    <i class="fas fa-star"> </i>
                    <i class="fas fa-star"> </i>
                    <i class="fas fa-star"> </i>
                    <i class="fas fa-star-half-alt"> </i>
                    <span class="ml-2 text-gray-700 font-medium"> 4.8/5 </span>
                  </div>
                  <p class="text-sm text-gray-500">来自10,000+用户的好评</p>
                </div>
              </div> -->
            </div>
            <div class="lg:w-4/5 relative" data-ytextravalue="extra-qrjgpbcz3">
              <div
                class="relative z-10 rounded-2xl overflow-hidden transition-transform duration-500"
                data-ytoriginindex="0"
                data-ytindex="0"
              >
                <img
                  :alt="name + '平台界面'"
                  class="w-full h-auto"
                  :src="bannerImage"
                  data-selectorname="#id-jx9kq"
                  style
                />
              </div>
              <div
                class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gradient-to-r from-primary/20 to-accent/20 rounded-full blur-3xl -z-10"
                data-ytoriginindex="1"
                data-ytindex="1"
              ></div>
              <!-- <div
                class="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-lg flex items-center space-x-3 animate-pulse"
                data-ytparentvalue="extra-qrjgpbcz3"
                data-ytoriginindex="2"
                data-ytindex="2"
                style="
                  opacity: 0.913532;
                  color: rgb(31, 41, 55);
                  font-family: Inter, system-ui, sans-serif;
                  font-size: 16px;
                  font-weight: 400;
                  font-style: normal;
                  line-height: 24px;
                  text-align: start;
                  text-indent: 0px;
                "
              >
                <div
                  class="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-secondary"
                >
                  <i class="fas fa-check text-xl"> </i>
                </div>
                <div>
                  <p class="text-sm font-medium">问卷创建成功</p>
                  <p class="text-xs text-gray-500">刚刚完成</p>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </section>
      <!-- 客户标志 -->
      <!-- <div
        class="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-70"
        data-selectorname="#id-7qu74"
        data-ytparentvalue="extra-0aa3iutsx"
        data-ytoriginindex="1"
        data-ytindex="2"
        style="
          opacity: 0.7;
          color: rgb(31, 41, 55);
          font-family: Inter, system-ui, sans-serif;
          font-size: 16px;
          font-weight: 400;
          font-style: normal;
          line-height: 24px;
          text-align: start;
          text-indent: 0px;
        "
      >
        <div class="h-8 md:h-10 flex items-center" style>
          <i class="fas fa-building text-2xl text-gray-400" style> </i>
          <span
            class="ml-2 text-gray-500"
            style="outline: none"
            contenteditable="false"
            data-yteditvalue
          >
            <br />
          </span>
        </div>
        <div
          class="h-8 md:h-10 flex items-center"
          style
          data-ytextravalue="extra-dz79vd1c3"
        >
          <i
            class="fas fa-university text-2xl text-gray-400"
            data-ytparentvalue="extra-dz79vd1c3"
            data-ytoriginindex="0"
            data-ytindex="0"
          >
          </i>
          <span
            class="ml-2 text-gray-500"
            style="outline: none"
            contenteditable="false"
            data-yteditvalue
            data-ytoriginindex="1"
            data-ytindex="1"
          >
            <br />
          </span>
        </div>
        <div class="h-8 md:h-10 flex items-center" style>
          <i class="fas fa-school text-2xl text-gray-400" style> </i>
          <span
            class="ml-2 text-gray-500"
            style="outline: none"
            contenteditable="false"
            data-yteditvalue
          >
            <br />
          </span>
        </div>
        <div class="h-8 md:h-10 flex items-center" style>
          <i class="fas fa-medkit text-2xl text-gray-400" style> </i>
          <span
            class="ml-2 text-gray-500"
            style="outline: none"
            contenteditable="false"
            data-yteditvalue
          >
            <br />
          </span>
        </div>
        <div class="h-8 md:h-10 flex items-center" style>
          <i class="fas fa-shopping-bag text-2xl text-gray-400" style> </i>
          <span
            class="ml-2 text-gray-500"
            contenteditable="false"
            style="outline: none"
            data-yteditvalue
          >
            <br />
          </span>
        </div>
      </div> -->
      <!-- <section
        class="py-12 bg-white"
        data-ytoriginindex="2"
        data-ytindex="3"
        data-ytextravalue="extra-ctx7hxhen"
        data-ytparentvalue="extra-hec6e6dv1"
      >
        <div
          class="container mx-auto px-4 sm:px-6 lg:px-8"
          data-ytextravalue="extra-0aa3iutsx"
          data-ytparentvalue="extra-ctx7hxhen"
          data-ytoriginindex="0"
          data-ytindex="0"
        >
          <p
            class="text-center text-gray-500 text-sm uppercase tracking-wider mb-8"
            data-ytoriginindex="0"
            data-ytindex="0"
            contenteditable="false"
            style="
              outline: none;
              opacity: 1;
              color: rgb(107, 114, 128);
              font-family: Inter, system-ui, sans-serif;
              font-size: 14px;
              font-weight: 400;
              font-style: normal;
              line-height: 20px;
              text-align: center;
              text-indent: 0px;
            "
            data-yteditvalue
            data-ytparentvalue="extra-0aa3iutsx"
          >
            <br />
          </p>
        </div>
      </section> -->
      <!-- 功能特点 -->
      <section
        class="py-20 bg-gray-50"
        id="features"
        data-ytoriginindex="3"
        data-ytindex="4"
        data-ytparentvalue="extra-fb3wyivzp"
      >
        <div class="container mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center max-w-3xl mx-auto mb-16">
            <h2 class="text-5xl font-bold text-dark mb-4">
              强大功能，简单操作
            </h2>
            <p class="text-lg text-gray-600">
              {{
                name
              }}提供全方位的调研工具，让您轻松完成从问卷设计到数据分析的全过程
            </p>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <!-- 功能卡片1 -->
            <div class="bg-white rounded-xl p-6 shadow-sm card-hover">
              <div
                class="w-14 h-14 rounded-lg bg-blue-100 flex items-center justify-center text-primary mb-5"
              >
                <i class="fas fa-pencil-alt text-2xl"> </i>
              </div>
              <h3 class="text-xl font-bold mb-3">拖拽式问卷设计</h3>
              <p class="text-gray-600 mb-4">
                无需编程知识，通过简单拖拽即可创建专业问卷，支持多种题型和自定义主题。
              </p>
              <!-- <a
                class="text-primary font-medium flex items-center hover:text-primary/80 transition-colors"
                href="javascript:void(0);"
                data-yteditvalue
                data-ytextravalue="extra-8om0v0r0z"
              >
                <i
                  class="fas fa-arrow-right ml-2 text-sm"
                  data-ytparentvalue="extra-8om0v0r0z"
                  data-ytoriginindex="0"
                  data-ytindex="0"
                >
                </i>
              </a> -->
            </div>
            <!-- 功能卡片2 -->
            <div class="bg-white rounded-xl p-6 shadow-sm card-hover">
              <div
                class="w-14 h-14 rounded-lg bg-green-100 flex items-center justify-center text-secondary mb-5"
              >
                <i class="fas fa-chart-pie text-2xl"> </i>
              </div>
              <h3 class="text-xl font-bold mb-3">实时数据分析</h3>
              <p class="text-gray-600 mb-4">
                问卷收集到的数据实时更新，自动生成可视化图表，支持多维度交叉分析。
              </p>
              <!-- <a
                class="text-primary font-medium flex items-center hover:text-primary/80 transition-colors"
                href="javascript:void(0);"
                data-yteditvalue
              >
                <i class="fas fa-arrow-right ml-2 text-sm"> </i>
              </a> -->
            </div>
            <!-- 功能卡片3 -->
            <div class="bg-white rounded-xl p-6 shadow-sm card-hover">
              <div
                class="w-14 h-14 rounded-lg bg-purple-100 flex items-center justify-center text-accent mb-5"
              >
                <i class="fas fa-share-alt text-2xl"> </i>
              </div>
              <h3 class="text-xl font-bold mb-3">多渠道分发</h3>
              <p class="text-gray-600 mb-4">
                支持微信、QQ、邮件、短信等多种分发渠道，轻松触达目标人群。
              </p>
              <!-- <a
                class="text-primary font-medium flex items-center hover:text-primary/80 transition-colors"
                href="javascript:void(0);"
                data-yteditvalue
              >
                <i class="fas fa-arrow-right ml-2 text-sm"> </i>
              </a> -->
            </div>
            <!-- 功能卡片4 -->
            <div
              class="bg-white rounded-xl p-6 shadow-sm card-hover"
              data-ytextravalue="extra-890gqyb7c"
            >
              <div
                class="w-14 h-14 rounded-lg bg-yellow-100 flex items-center justify-center text-yellow-500 mb-5"
                data-ytoriginindex="0"
                data-ytindex="0"
              >
                <i class="fas fa-shield-alt text-2xl"> </i>
              </div>
              <h3
                class="text-xl font-bold mb-3"
                data-ytoriginindex="1"
                data-ytindex="1"
                data-yteditvalue="海量模板"
              >
                海量模板
              </h3>
              <p
                class="text-gray-600 mb-4"
                data-ytoriginindex="2"
                data-ytindex="2"
                data-yteditvalue="千套精美模板覆盖市场教育人力生活等，一键启用，秒速开工！"
              >
                千套精美模板覆盖市场教育人力生活等，一键启用，秒速开工！
              </p>
              <!-- <a
                class="text-primary font-medium flex items-center hover:text-primary/80 transition-colors"
                href="javascript:void(0);"
                data-yteditvalue
                data-ytparentvalue="extra-890gqyb7c"
                data-ytoriginindex="3"
                data-ytindex="3"
              >
                <i class="fas fa-arrow-right ml-2 text-sm"> </i>
              </a> -->
            </div>
            <!-- 功能卡片5 -->
            <div class="bg-white rounded-xl p-6 shadow-sm card-hover">
              <div
                class="w-14 h-14 rounded-lg bg-red-100 flex items-center justify-center text-red-500 mb-5"
              >
                <i class="fas fa-file-export text-2xl"> </i>
              </div>
              <h3 class="text-xl font-bold mb-3" data-yteditvalue="AI智能辅助">
                AI智能辅助
              </h3>
              <p
                class="text-gray-600 mb-4"
                data-yteditvalue="AI智能推荐题目、帮你完善问卷逻辑；输入主题秒获取问卷完整框架，告别空白焦虑，效率飙升90%"
              >
                AI智能推荐题目、帮你完善问卷逻辑；输入主题秒获取问卷完整框架，告别空白焦虑，效率飙升90%
              </p>
              <!-- <a
                class="text-primary font-medium flex items-center hover:text-primary/80 transition-colors"
                href="javascript:void(0);"
                data-yteditvalue
              >
                <i class="fas fa-arrow-right ml-2 text-sm"> </i>
              </a> -->
            </div>
            <!-- 功能卡片6 -->
            <div class="bg-white rounded-xl p-6 shadow-sm card-hover">
              <div
                class="w-14 h-14 rounded-lg bg-indigo-100 flex items-center justify-center text-indigo-500 mb-5"
              >
                <i class="fas fa-users text-2xl"> </i>
              </div>
              <h3 class="text-xl font-bold mb-3">样本服务</h3>
              <p class="text-gray-600 mb-4">
                提供精准样本库，帮助您快速找到目标受访者，提高调研效率和质量。
              </p>
              <!-- <a
                class="text-primary font-medium flex items-center hover:text-primary/80 transition-colors"
                href="javascript:void(0);"
                data-yteditvalue
              >
                <i class="fas fa-arrow-right ml-2 text-sm"> </i>
              </a> -->
            </div>
          </div>
        </div>
      </section>
      <!-- 工作流程 -->
      <section
        class="py-20 bg-white"
        data-ytoriginindex="4"
        data-ytindex="5"
        id="templates"
      >
        <div class="container mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center max-w-3xl mx-auto mb-16">
            <h2 class="text-5xl font-bold text-dark mb-4">
              简单三步，完成专业调研
            </h2>
            <p class="text-lg text-gray-600">
              {{ name }}简化了调研流程，让您专注于获取有价值的洞察
            </p>
          </div>
          <div class="relative">
            <!-- 连接线 -->
            <!-- <div
              class="hidden md:block absolute top-1/4 left-0 w-full h-1 bg-gray-200 -z-10"
            ></div> -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4">
              <!-- 步骤1 -->
              <div class="flex flex-col items-center text-center">
                <div
                  class="w-20 h-20 rounded-full bg-primary text-white flex items-center justify-center text-2xl font-bold mb-6 relative z-10"
                >
                  1
                </div>
                <h3 class="text-xl font-bold mb-3">创建问卷</h3>
                <p class="text-gray-600">
                  选择模板或从头开始，拖拽添加问题，自定义主题和逻辑跳转
                </p>
                <div
                  class="mt-6 w-40 h-40 rounded-lg overflow-hidden shadow-md"
                >
                  <img
                    alt="创建问卷"
                    class="w-full h-full object-cover"
                    src="https://design.gemcoder.com/staticResource/echoAiSystemImages/9e869d6f887e2e2164de1eb982f160ce.png"
                  />
                </div>
              </div>
              <!-- 步骤2 -->
              <div class="flex flex-col items-center text-center">
                <div
                  class="w-20 h-20 rounded-full bg-primary text-white flex items-center justify-center text-2xl font-bold mb-6 relative z-10"
                >
                  2
                </div>
                <h3 class="text-xl font-bold mb-3">分发收集</h3>
                <p class="text-gray-600">
                  通过多种渠道分发问卷，实时监控收集进度，设置提醒和截止日期
                </p>
                <div
                  class="mt-6 w-40 h-40 rounded-lg overflow-hidden shadow-md"
                >
                  <img
                    alt="分发收集"
                    class="w-full h-full object-cover"
                    src="https://design.gemcoder.com/staticResource/echoAiSystemImages/15709491fe29384a3ca33d57e19f3dfb.png"
                  />
                </div>
              </div>
              <!-- 步骤3 -->
              <div class="flex flex-col items-center text-center">
                <div
                  class="w-20 h-20 rounded-full bg-primary text-white flex items-center justify-center text-2xl font-bold mb-6 relative z-10"
                >
                  3
                </div>
                <h3 class="text-xl font-bold mb-3">分析报告</h3>
                <p class="text-gray-600">
                  查看实时统计结果，生成可视化图表，导出专业报告
                </p>
                <div
                  class="mt-6 w-40 h-40 rounded-lg overflow-hidden shadow-md"
                >
                  <img
                    alt="分析报告"
                    class="w-full h-full object-cover"
                    src="https://design.gemcoder.com/staticResource/echoAiSystemImages/5373998d5c9aec3d7a2536febe400fe0.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 模板中心 -->
      <section class="py-20 bg-gray-50" data-ytoriginindex="5" data-ytindex="6">
        <div class="container mx-auto px-4 sm:px-6 lg:px-8">
          <div
            class="flex flex-col md:flex-row justify-between items-start md:items-end mb-12"
          >
            <div>
              <h2 class="text-5xl font-bold text-dark mb-4">
                专业模板，快速上手
              </h2>
              <p class="text-lg text-gray-600 max-w-2xl">
                精选100+行业模板，覆盖各种调研场景，帮您节省80%的问卷设计时间
              </p>
            </div>
            <!-- <a
              class="mt-4 md:mt-0 inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors"
              href="javascript:void(0);"
            >
              查看全部模板
              <i class="fas fa-arrow-right ml-2"> </i>
            </a> -->
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <!-- 模板1 -->
            <div
              class="bg-white rounded-xl overflow-hidden shadow-sm card-hover"
            >
              <div class="h-40 overflow-hidden">
                <img
                  alt="客户满意度调查"
                  class="w-full h-full object-cover"
                  src="https://design.gemcoder.com/staticResource/echoAiSystemImages/a4a9033862cb5642791384ff03c992da.png"
                />
              </div>
              <div class="p-5">
                <div class="flex items-center text-sm text-gray-500 mb-2">
                  <i class="fas fa-tag mr-1"> </i>
                  <span> 客户反馈 </span>
                </div>
                <h3 class="font-bold text-lg mb-2">客户满意度调查</h3>
                <p class="text-gray-600 text-sm mb-4">
                  评估客户对产品和服务的满意度，收集改进建议
                </p>
                <!-- <a
                  class="block text-center py-2 border border-primary text-primary rounded-lg hover:bg-primary hover:text-white transition-colors text-sm font-medium"
                  href="javascript:void(0);"
                >
                  使用模板
                </a> -->
              </div>
            </div>
            <!-- 模板2 -->
            <div
              class="bg-white rounded-xl overflow-hidden shadow-sm card-hover"
            >
              <div class="h-40 overflow-hidden">
                <img
                  alt="员工敬业度调查"
                  class="w-full h-full object-cover"
                  src="https://design.gemcoder.com/staticResource/echoAiSystemImages/ee57edc2a10dfda8253c246596cc23bb.png"
                />
              </div>
              <div class="p-5">
                <div class="flex items-center text-sm text-gray-500 mb-2">
                  <i class="fas fa-tag mr-1"> </i>
                  <span> 人力资源 </span>
                </div>
                <h3 class="font-bold text-lg mb-2">员工敬业度调查</h3>
                <p class="text-gray-600 text-sm mb-4">
                  了解员工工作状态，提升团队凝聚力和工作效率
                </p>
                <!-- <a
                  class="block text-center py-2 border border-primary text-primary rounded-lg hover:bg-primary hover:text-white transition-colors text-sm font-medium"
                  href="javascript:void(0);"
                >
                  使用模板
                </a> -->
              </div>
            </div>
            <!-- 模板3 -->
            <div
              class="bg-white rounded-xl overflow-hidden shadow-sm card-hover"
            >
              <div class="h-40 overflow-hidden">
                <img
                  alt="市场调研问卷"
                  class="w-full h-full object-cover"
                  src="https://design.gemcoder.com/staticResource/echoAiSystemImages/089486c2c4c269bf6e08a24784c33c07.png"
                />
              </div>
              <div class="p-5">
                <div class="flex items-center text-sm text-gray-500 mb-2">
                  <i class="fas fa-tag mr-1"> </i>
                  <span> 市场营销 </span>
                </div>
                <h3 class="font-bold text-lg mb-2">市场调研问卷</h3>
                <p class="text-gray-600 text-sm mb-4">
                  探索市场需求，了解消费者偏好，优化产品定位
                </p>
                <!-- <a
                  class="block text-center py-2 border border-primary text-primary rounded-lg hover:bg-primary hover:text-white transition-colors text-sm font-medium"
                  href="javascript:void(0);"
                >
                  使用模板
                </a> -->
              </div>
            </div>
            <!-- 模板4 -->
            <div
              class="bg-white rounded-xl overflow-hidden shadow-sm card-hover"
            >
              <div class="h-40 overflow-hidden">
                <img
                  alt="课程满意度评价"
                  class="w-full h-full object-cover"
                  src="https://design.gemcoder.com/staticResource/echoAiSystemImages/d61c255a6fefa98b3090e234e27c7fa3.png"
                />
              </div>
              <div class="p-5">
                <div class="flex items-center text-sm text-gray-500 mb-2">
                  <i class="fas fa-tag mr-1"> </i>
                  <span> 教育机构 </span>
                </div>
                <h3 class="font-bold text-lg mb-2">课程满意度评价</h3>
                <p class="text-gray-600 text-sm mb-4">
                  收集学生对课程内容、教学质量的反馈意见
                </p>
                <!-- <a
                  class="block text-center py-2 border border-primary text-primary rounded-lg hover:bg-primary hover:text-white transition-colors text-sm font-medium"
                  href="javascript:void(0);"
                >
                  使用模板
                </a> -->
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 数据统计 -->
      <section
        class="py-16 bg-primary text-white"
        data-ytoriginindex="6"
        data-ytindex="7"
      >
        <div class="container mx-auto px-4 sm:px-6 lg:px-8">
          <div class="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div data-ytextravalue="extra-wjyxthhga">
              <div
                class="text-4xl md:text-5xl font-bold mb-2 counter"
                data-target="1000000"
                data-ytparentvalue="extra-wjyxthhga"
                data-ytoriginindex="0"
                data-ytindex="0"
              >
                1,000,000
              </div>
              <p class="text-blue-100" data-ytoriginindex="1" data-ytindex="1">
                问卷创建量
              </p>
            </div>
            <div>
              <div
                class="text-4xl md:text-5xl font-bold mb-2 counter"
                data-target="50000"
              >
                50,000
              </div>
              <p class="text-blue-100">企业用户</p>
            </div>
            <div>
              <div
                class="text-4xl md:text-5xl font-bold mb-2 counter"
                data-target="98"
              >
                98
              </div>
              <p class="text-blue-100">用户满意度(%)</p>
            </div>
            <div>
              <div
                class="text-4xl md:text-5xl font-bold mb-2 counter"
                data-target="100"
                data-yteditvalue="行业覆盖"
              >
                100
              </div>
              <p class="text-blue-100" data-yteditvalue="行业覆盖">行业覆盖</p>
            </div>
          </div>
        </div>
      </section>
      <!-- 用户评价 -->
      <section
        class="py-20 bg-white"
        id="testimonials"
        data-ytoriginindex="7"
        data-ytindex="8"
      >
        <div class="container mx-auto px-4 sm:px-6 lg:px-8">
          <div
            class="text-center max-w-3xl mx-auto mb-16"
            data-ytextravalue="extra-y1s5z2arq"
          >
            <h2
              class="text-5xl font-bold text-dark mb-4"
              data-ytparentvalue="extra-y1s5z2arq"
              data-ytoriginindex="0"
              data-ytindex="0"
            >
              用户的真实反馈
            </h2>
            <p
              class="text-lg text-gray-600"
              data-ytoriginindex="1"
              data-ytindex="1"
            >
              来自各行各业的用户正在使用{{ name }}提升调研效率
            </p>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
            <!-- 评价1 -->
            <div class="bg-gray-50 p-6 rounded-xl shadow-sm">
              <div class="flex text-yellow-400 mb-4">
                <i class="fas fa-star"> </i>
                <i class="fas fa-star"> </i>
                <i class="fas fa-star"> </i>
                <i class="fas fa-star"> </i>
                <i class="fas fa-star"> </i>
              </div>
              <p class="text-gray-700 mb-6">
                "{{
                  name
                }}极大地简化了我们的市场调研流程，拖拽式设计让非专业人士也能创建出高质量问卷，数据分析功能更是直观强大。"
              </p>
              <div class="flex items-center">
                <img
                  alt="用户头像"
                  class="w-12 h-12 rounded-full mr-4"
                  src="https://design.gemcoder.com/staticResource/echoAiSystemImages/265fe5bbd5c5fc772a8fe23b6f1976d6.png"
                />
                <div>
                  <h4 class="font-bold">张明</h4>
                  <p class="text-sm text-gray-500">市场部经理 @ 科技公司</p>
                </div>
              </div>
            </div>
            <!-- 评价2 -->
            <div class="bg-gray-50 p-6 rounded-xl shadow-sm">
              <div class="flex text-yellow-400 mb-4">
                <i class="fas fa-star"> </i>
                <i class="fas fa-star"> </i>
                <i class="fas fa-star"> </i>
                <i class="fas fa-star"> </i>
                <i class="fas fa-star"> </i>
              </div>
              <p class="text-gray-700 mb-6">
                "作为一名大学教师，我需要经常进行学生满意度调查。{{
                  name
                }}的教育类模板非常实用，数据分析功能帮助我快速了解学生需求。"
              </p>
              <div class="flex items-center">
                <img
                  alt="用户头像"
                  class="w-12 h-12 rounded-full mr-4"
                  src="https://design.gemcoder.com/staticResource/echoAiSystemImages/7109d1b5dcf5617d2c4b3eff55c51ae6.png"
                />
                <div>
                  <h4 class="font-bold">李婷</h4>
                  <p class="text-sm text-gray-500">副教授 @ 师范大学</p>
                </div>
              </div>
            </div>
            <!-- 评价3 -->
            <div class="bg-gray-50 p-6 rounded-xl shadow-sm">
              <div class="flex text-yellow-400 mb-4">
                <i class="fas fa-star"> </i>
                <i class="fas fa-star"> </i>
                <i class="fas fa-star"> </i>
                <i class="fas fa-star"> </i>
                <i class="fas fa-star-half-alt"> </i>
              </div>
              <p class="text-gray-700 mb-6">
                "我们公司使用{{
                  name
                }}进行客户满意度调查已经一年多了，系统稳定，数据安全，客服响应迅速，是值得信赖的调研工具。"
              </p>
              <div class="flex items-center">
                <img
                  alt="用户头像"
                  class="w-12 h-12 rounded-full mr-4"
                  src="https://design.gemcoder.com/staticResource/echoAiSystemImages/9b5ced8eaa891c892e5682027edadc5d.png"
                />
                <div>
                  <h4 class="font-bold">王强</h4>
                  <p class="text-sm text-gray-500">客服总监 @ 电商企业</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 常见问题 -->
      <!-- <section class="py-20 bg-white" data-ytoriginindex="8" data-ytindex="9">
        <div class="container mx-auto px-4 sm:px-6 lg:px-8">
          <div class="text-center max-w-3xl mx-auto mb-16">
            <h2 class="text-5xl font-bold text-dark mb-4">常见问题</h2>
            <p class="text-lg text-gray-600">
              我们整理了用户最常问的问题，希望能帮助您更好地了解{{ name }}
            </p>
          </div>
          <div class="max-w-3xl mx-auto">
            <div class="space-y-4">
              <div class="border border-gray-200 rounded-lg overflow-hidden">
                <button
                  class="faq-toggle w-full flex justify-between items-center p-5 text-left font-medium focus:outline-none"
                >
                  <span> {{ name }}适合哪些用户使用？ </span>
                  <i
                    class="fas fa-chevron-down text-gray-400 transition-transform duration-300"
                  >
                  </i>
                </button>
                <div class="faq-content hidden px-5 pb-5 text-gray-600">
                  {{
                    name
                  }}适合各种规模的用户，包括个人用户、中小企业、大型企业、教育机构、政府部门等。无论您需要进行市场调研、客户满意度调查、员工敬业度评估还是学术研究，{{
                    name
                  }}都能满足您的需求。
                </div>
              </div>
              <div class="border border-gray-200 rounded-lg overflow-hidden">
                <button
                  class="faq-toggle w-full flex justify-between items-center p-5 text-left font-medium focus:outline-none"
                >
                  <span> 如何确保我的问卷数据安全？ </span>
                  <i
                    class="fas fa-chevron-down text-gray-400 transition-transform duration-300"
                  >
                  </i>
                </button>
                <div class="faq-content hidden px-5 pb-5 text-gray-600">
                  {{
                    name
                  }}采用银行级别的数据加密技术，所有数据传输和存储都经过加密处理。我们严格遵守数据保护法规，不会向第三方泄露您的任何数据。企业版用户还可以获得专属的数据存储方案和更高级别的安全保障。
                </div>
              </div>
              <div class="border border-gray-200 rounded-lg overflow-hidden">
                <button
                  class="faq-toggle w-full flex justify-between items-center p-5 text-left font-medium focus:outline-none"
                >
                  <span> 免费版和付费版有什么区别？ </span>
                  <i
                    class="fas fa-chevron-down text-gray-400 transition-transform duration-300"
                  >
                  </i>
                </button>
                <div class="faq-content hidden px-5 pb-5 text-gray-600">
                  免费版适合个人用户和简单的调研需求，提供基础的问卷创建和数据分析功能，但有问卷数量和答卷数量的限制。付费版（专业版和企业版）则提供无限问卷创建、更多答卷数量、高级题型、高级数据分析、品牌定制等功能，适合企业和团队使用。详细区别请查看我们的价格方案页面。
                </div>
              </div>
              <div class="border border-gray-200 rounded-lg overflow-hidden">
                <button
                  class="faq-toggle w-full flex justify-between items-center p-5 text-left font-medium focus:outline-none"
                >
                  <span> 可以将问卷数据导出到其他软件吗？ </span>
                  <i
                    class="fas fa-chevron-down text-gray-400 transition-transform duration-300"
                  >
                  </i>
                </button>
                <div class="faq-content hidden px-5 pb-5 text-gray-600">
                  是的，{{
                    name
                  }}支持将问卷数据导出为多种格式，包括Excel、CSV、PDF等。专业版和企业版用户还可以通过API接口将数据同步到其他系统，如CRM、数据分析软件等，实现数据的无缝对接。
                </div>
              </div>
              <div class="border border-gray-200 rounded-lg overflow-hidden">
                <button
                  class="faq-toggle w-full flex justify-between items-center p-5 text-left font-medium focus:outline-none"
                >
                  <span> 如果我有特殊需求，可以定制功能吗？ </span>
                  <i
                    class="fas fa-chevron-down text-gray-400 transition-transform duration-300"
                  >
                  </i>
                </button>
                <div class="faq-content hidden px-5 pb-5 text-gray-600">
                  企业版用户可以享受一定程度的功能定制服务。我们的专业团队会根据您的具体需求，提供定制化的解决方案，包括定制题型、特殊逻辑、数据接口开发等。如果您有定制需求，请联系我们的销售团队详细咨询。
                </div>
              </div>
            </div>
            <div class="mt-10 text-center">
              <p class="text-gray-600 mb-4">还有其他问题？</p>
              <a
                class="text-primary font-medium hover:text-primary/80 transition-colors"
                href="javascript:void(0);"
              >
                联系客服获取帮助
              </a>
            </div>
          </div>
        </div>
      </section> -->
      <!-- 行动召唤 -->
      <section
        class="py-20 bg-gradient-to-r from-primary to-accent text-white"
        data-ytoriginindex="9"
        data-ytindex="10"
      >
        <div class="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 class="text-5xl font-bold mb-6">开始您的调研之旅</h2>
          <p class="text-xl text-blue-100 mb-10 max-w-3xl mx-auto">
            立即注册{{
              name
            }}，免费创建您的第一份专业问卷，体验高效便捷的调研流程
          </p>
          <div
            class="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4"
          >
            <a
              class="bg-white text-primary px-8 py-3 rounded-lg font-medium text-center transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all"
              href="javascript:void(0);"
              @click="handleLoginClick"
            >
              免费注册，立即使用
            </a>
            <!-- <a
              class="bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-medium text-center transition-colors hover:bg-white/10"
              href="javascript:void(0);"
            >
              预约演示
            </a> -->
          </div>
        </div>
      </section>
      <!-- 页脚 -->
      <footer
        class="w-full bg-dark text-gray-400 pt-8 pb-8 min-w-[1600px]"
        data-ytoriginindex="10"
        data-ytindex="11"
      >
        <div
          class="container mx-auto px-4 sm:px-6 lg:px-8 flex justify-between"
        >
          <div class="flex">
            <div class="mr-48">
              <h4 class="text-white font-bold mb-12">快捷导航</h4>
              <ul class="space-y-2">
                <li class="mb-4 w-[180px]">
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    首页
                  </a>
                </li>
                <li class="w-[180px]">
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    创建活动
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 class="text-white font-bold mb-12">联系我们</h4>
              <ul class="space-y-2">
                <li class="mb-4 w-[320px]">
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    电话：0451-84616340
                  </a>
                </li>
                <li class="w-[320px]">
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    邮箱：huotoupiao@youzhiapp.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="flex justify-end" v-if="!isFeiShuLogin">
            <div class="qr-popup mr-4">
              <img :src="miniProgramCode" alt="小程序二维码" />
              <p>打开小程序</p>
            </div>
            <div class="qr-popup">
              <img :src="kefuCode" alt="客服二维码" />
              <p>扫码联系客服</p>
            </div>
          </div>
        </div>
        <div class="container mx-auto lg:px-12 flex justify-between mt-8">
          <p>© {{ name }} {{ companyName }}</p>
          <p>{{ filing }}</p>
        </div>
      </footer>
      <!-- <footer
        class="bg-dark text-gray-400 pt-16 pb-8"
        data-ytoriginindex="10"
        data-ytindex="11"
      >
        <div class="container mx-auto px-4 sm:px-6 lg:px-8">
          <div
            class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12"
          >
            <div class="lg:col-span-2">
              <div class="flex items-center mb-4">
                <div class="w-10 h-10 mr-3">
                  <img :src="logo" alt="" />
                </div>
                <span class="text-xl font-bold text-white"> {{ name }} </span>
              </div>
              <p class="mb-6 max-w-md">
                {{
                  name
                }}是专业的在线调研平台，提供问卷设计、数据收集和分析的一站式解决方案，帮助您轻松获取有价值的洞察。
              </p>
              <div class="flex space-x-4">
                <a
                  class="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors"
                  href="javascript:void(0);"
                >
                  <i class="fab fa-weixin"> </i>
                </a>
                <a
                  class="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors"
                  href="javascript:void(0);"
                >
                  <i class="fab fa-weibo"> </i>
                </a>
                <a
                  class="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors"
                  href="javascript:void(0);"
                >
                  <i class="fab fa-qq"> </i>
                </a>
                <a
                  class="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors"
                  href="javascript:void(0);"
                >
                  <i class="fas fa-envelope"> </i>
                </a>
              </div>
            </div>
            <div>
              <h4 class="text-white font-bold mb-4">产品</h4>
              <ul class="space-y-2">
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    功能特点
                  </a>
                </li>
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    模板中心
                  </a>
                </li>
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                  </a>
                </li>
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    样本服务
                  </a>
                </li>
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    API接口
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 class="text-white font-bold mb-4">资源</h4>
              <ul class="space-y-2">
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    帮助中心
                  </a>
                </li>
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    视频教程
                  </a>
                </li>
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    调研学院
                  </a>
                </li>
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    案例研究
                  </a>
                </li>
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    常见问题
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 class="text-white font-bold mb-4">公司</h4>
              <ul class="space-y-2">
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    关于我们
                  </a>
                </li>
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    客户案例
                  </a>
                </li>
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    招贤纳士
                  </a>
                </li>
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    联系我们
                  </a>
                </li>
                <li>
                  <a
                    class="hover:text-white transition-colors"
                    href="javascript:void(0);"
                  >
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center"
          >
            <p>© {{ name }} {{ companyName }} {{ filing }}</p>
            <div class="flex space-x-6 mt-4 md:mt-0">
              <a
                class="hover:text-white transition-colors"
                href="javascript:void(0);"
              >
                服务条款
              </a>
              <a
                class="hover:text-white transition-colors"
                href="javascript:void(0);"
              >
                隐私政策
              </a>
              <a
                class="hover:text-white transition-colors"
                href="javascript:void(0);"
              >
                Cookie政策
              </a>
            </div>
          </div>
        </div>
      </footer> -->
    </div>
  </div>
</template>

<script>
import config from "@/utils/config";
export default {
  data() {
    return {
      name: config.name,
      logo: config.logo,
      companyName: config.companyName,
      filing: config.filing,
      logoTitle: config.logoTitle,
      miniProgramCode: config.miniProgramCode,
      kefuCode: config.kefuCode,
      bannerImage: config.bannerImage,
      isFeiShuLogin: false, 

    };
  },
  mounted() {
    // 页面加载时初始化渲染
    document.addEventListener("DOMContentLoaded", function () {
      // 导航栏滚动效果
      var navbar = document.getElementById("navbar");
      window.addEventListener("scroll", function () {
        if (window.scrollY > 50) {
          navbar.classList.add("shadow-md");
          navbar.classList.remove("shadow-sm");
        } else {
          navbar.classList.remove("shadow-md");
          navbar.classList.add("shadow-sm");
        }
      });

      // 移动端菜单切换
      var menuToggle = document.getElementById("menu-toggle");
      var mobileMenu = document.getElementById("mobile-menu");
      menuToggle.addEventListener("click", function () {
        mobileMenu.classList.toggle("hidden");
        var icon = menuToggle.querySelector("i");
        if (mobileMenu.classList.contains("hidden")) {
          icon.classList.remove("fa-times");
          icon.classList.add("fa-bars");
        } else {
          icon.classList.remove("fa-bars");
          icon.classList.add("fa-times");
        }
      });

      // 平滑滚动
      document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener("click", function (e) {
          e.preventDefault();

          // 关闭移动菜单（如果打开）
          if (!mobileMenu.classList.contains("hidden")) {
            mobileMenu.classList.add("hidden");
            var icon = menuToggle.querySelector("i");
            icon.classList.remove("fa-times");
            icon.classList.add("fa-bars");
          }
          var targetId = this.getAttribute("href");
          if (targetId === "#") return;
          var targetElement = document.querySelector(targetId);
          if (targetElement) {
            window.scrollTo({
              top: targetElement.offsetTop - 80,
              behavior: "smooth",
            });
          }
        });
      });

      // FAQ切换
      var faqToggles = document.querySelectorAll(".faq-toggle");
      faqToggles.forEach(function (toggle) {
        toggle.addEventListener("click", function () {
          var content = toggle.nextElementSibling;
          var icon = toggle.querySelector("i");

          // 关闭其他所有FAQ
          document.querySelectorAll(".faq-content").forEach(function (item) {
            if (item !== content && !item.classList.contains("hidden")) {
              item.classList.add("hidden");
              item.previousElementSibling
                .querySelector("i")
                .classList.remove("rotate-180");
            }
          });

          // 切换当前FAQ
          content.classList.toggle("hidden");
          icon.classList.toggle("rotate-180");
        });
      });

      // 数字计数动画
      var counters = document.querySelectorAll(".counter");
      var speed = 200; // 动画速度

      var animateCounters = function animateCounters() {
        counters.forEach(function (counter) {
          var target = +counter.getAttribute("data-target");
          var count = +counter.innerText;
          var increment = target / speed;
          if (count < target) {
            counter.innerText = Math.ceil(count + increment);
            setTimeout(animateCounters, 1);
          } else {
            counter.innerText = target.toLocaleString();
          }
        });
      };

      // 监听元素是否在视口中
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateCounters();
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.5,
        }
      );

      // 观察计数器容器
      if (counters.length > 0) {
        observer.observe(counters[0].parentElement.parentElement.parentElement);
      }

      // 添加卡片悬停效果
      var cards = document.querySelectorAll(".card-hover");
      cards.forEach(function (card) {
        card.addEventListener("mouseenter", function () {
          card.classList.add("shadow-lg", "-translate-y-1");
        });
        card.addEventListener("mouseleave", function () {
          card.classList.remove("shadow-lg", "-translate-y-1");
        });
      });

      this.isFeiShuLogin = localStorage.getItem("isFeiShuLogin")==null?false:true; // 初始化isFeiShuLogin状态

    });
  },
  methods: {
    handleLoginClick() {
      this.$router.push("/login");
    },
    handleTop() {
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style scoped>
@import "../../assets/style/reset.css";

.html-container {
  width: 100%;
  height: 100vh;
}

.hor-center {
  display: flex;
  justify-content: center;
}

.container-overflow {
  overflow: hidden;
}

.qr-popup {
  background: white;
  padding: 10px;
  width: 120px;
  border-radius: 8px;
  text-align: center;
}

.qr-popup img {
  width: 100px;
  height: 100px;
}

.qr-popup p {
  font-size: 14px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/LandingPage/index.vue